import { render, staticRenderFns } from "./summary-infos.vue?vue&type=template&id=5518df92&"
import script from "./summary-infos.vue?vue&type=script&lang=js&"
export * from "./summary-infos.vue?vue&type=script&lang=js&"
import style0 from "./summary-infos.vue?vue&type=style&index=0&id=5518df92&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports